<template>
  <div class="call-requests-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`), disabled: true },
        { title: this.$t('evocall.requests.title'), disabled: true }
      ]">

      <!-- Commented for now since it's not doing any search. Will be handled later
      <div slot="breadcrumbAfter">
        <Searchable :querySearch.sync="querySearch" :searchTooltip="{placement: 'left', content: this.$t('evocall.requests.search_tooltip')}" />
      </div>-->
    </Breadcrumbs>

    <div>
      <Dashboard
        ref="metrics"
        class="mb-5"
        :requests="requests"
        :waitingRoomModuleKey="waitingRoomModuleKey"
      />

      <v-client-table
        id="requestsTable"
        ref="requestsTable"
        name="referencesTable"
        :data="filteredRequests"
        :columns="columns"
        :options="requestsTableOptions"
        @row-click="displayConfirmationModal">

        <span slot="h__locked"></span>

        <span slot="requestNr" class="no-break" slot-scope="{ row }">
          {{ row.dailyRequestNr }}
        </span>

        <span v-show="row.openedBy !== null" slot="locked" slot-scope="{ row }">
          <span class="i-lock"></span>
        </span>

        <span slot="createdAt" class="no-break" slot-scope="{ row }">
          {{ row.createdAt | localTime('YYYY-MM-DD HH:mm') }}
        </span>

        <span slot = "estimatedAcceptTime" v-if="row.estimatedAcceptTime" class="no-break" slot-scope="{ row }">
          {{ row.estimatedAcceptTime | localTime('YYYY-MM-DD HH:mm') }}
        </span>
        <span slot = "estimatedAcceptTime" v-else class="no-break" slot-scope="{ row }">
          {{ "N/A" }}
        </span>

        <span slot="predictedAcceptedByNickname" class="no-break" slot-scope="{ row }">
          {{ row.predictedAcceptedByNickname || row.predicted_accepted_by_nickname || getPredictedAudiologistLabel(row) }}
        </span>

        <span slot="creator.name" class="no-break" slot-scope="{ row }">
          <span v-if="row.creator">
            {{ row.creator.nickname || row.creator.name }}
          </span>
        </span>

        <span v-if="row.openedBy !== null && row.openedByNickname !== null" slot="priority" slot-scope="{ row }" class="no-break" style="font-weight: 600">
          {{row.openedByNickname}}
        </span>
        <span v-else slot="priority" class="no-break" slot-scope="{row}">
          <va-popover
            :message="$t(`evocall.priorities.${row.priority.id}`)"
            offset="16"
            placement="left"
            :popoverClasses="[`priority--${row.priority.name.toLowerCase()}`]"
            :popoverStyles="{'border-radius': 0, 'color': '#ffffff'}"
            :backgroundColor="priorities[row.priority.id].color"
            >
            <span
              :class="[
                  `priority-icon priority--${row.priority.name.toLowerCase()}`,
                  priorities[row.priority.id].iconClass
                ]">

              </span>


          </va-popover>
        </span>

        <!--<span slot="obs" slot-scope="{row}" @click.stop="updateObservations(row)">
          <div class="clickable d-flex justify-content-center">
            <va-popover v-if="row.obs"
              :message="row.obs"
              placement="left"
            >
              <i class="i-has-comment-accent"></i>
            </va-popover>

            <span v-else>
              <i class="i-add-comment-gray"></i>
            </span>
          </div>
        </span>-->

      </v-client-table>

      <div
        v-if="userIsWaitingRoomAdmin"
        class="appointment-type-legend"
      >
        <span class="appointment-type-legend__title">
          {{ $t('virtual_waiting_room.waiting_room.appointment_type_legend') }}
        </span>
        <div class="appointment-type-legend__items">
          <div
            v-for="appointmentType in appointmentTypes"
            :key="appointmentType.id"
            class="appointment-type-legend__item"
          >
            <span
              class="appointment-type-legend__swatch"
              :style="{ backgroundColor: appointmentType.rowColor }"
            ></span>
            <span>{{ appointmentType.type }}</span>
          </div>
        </div>
      </div>
    </div>
    <RequestDetails
      v-if="showConfirmationModal"
      :component="component"
      :service-slug="serviceSlug"
      :request="selectedRequest"
      :waitingRoomModuleKey="waitingRoomModuleKey"
      @priority-updated="priorityUpdatedFromDetailsModal"
      @modal-closed="closeConfirmationModal"
    />
  </div>
</template>
<script>

import Vue from 'vue'
import {mapActions, mapState} from 'vuex'
import Dashboard from './Dashboard'
import { ClientTable } from 'vue-tables-2'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import SocketioService from "@/services/socketio.service";
import EventBus from "@/utils/EventBus";
import RequestDetails from "./RequestDetails"
import PriorityDetails from "@/components/evocall/requests/PriorityDetails";

Vue.use(ClientTable, {}, false, 'bootstrap4')

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {
    PriorityDetails,
    Breadcrumbs,
    Dashboard,
    RequestDetails
  },
  data () {
    return {
      selectedRequest: null,
      showConfirmationModal: false,
      filterListener: '',
      showResetIcon: false,
      requestsTableOptions: {
        requestFunction: (data) => {
          return this.$http.get(`${this.$store.state.virtual_waiting_room_server}/requests`, {
            params: data
          }).catch(function (e) {
            this.dispatch('error', e)
          }.bind(this))
        },
        responseAdapter: function (resp) {
          let data = this.getResponseData(resp)

          return {
            data: data.data.data,
            count: data.data.meta.total
          }
        },
        rowClassCallback: (row) => {
          const classes = []
          if (row.openedBy !== null && row.openedBy.id !== this.authUser.id) {
            classes.push('blocked-row')
          }
          if (this.userIsWaitingRoomAdmin) {
            const appointmentTypeClass = this.getAppointmentTypeRowClass(row.appointmentTypeId)
            if (appointmentTypeClass) {
              classes.push(appointmentTypeClass)
            }
          }
          return classes.join(' ')
        },
        filterable: false,
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('evocall.requests.empty_queue'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns_dropdown'),
        },
        sortable: ['updated_at', 'name', 'email', 'created_at', 'status'],
        headings: {
          'requestNr': this.$t('virtual_waiting_room.request_nr'),
          'estimatedAcceptTime': this.$t('evocall.requests.estimated_accept_time'),
          'customerName': this.$t('evocall.requests.person_name'),
          'customerNumber': this.$t('virtual_waiting_room.titles.customer_nr'),
          'entityName': this.$t('evocall.requests.entity'),
          'facilityName': this.$t('evocall.requests.facility'),
          'activity.name': this.$t('evocall.requests.activity'),
          'accepted.name': this.$t('evocall.requests.accepted'),
          'source.name': this.$t('evocall.requests.source'),
          'type.name': this.$t('evocall.requests.type'),
          'createdAt': this.$t('evocall.requests.created_at'),
          'dispenserNickname': this.$t('evocall.requests.creator'),
          'appointmentType': this.$t('clinical.appointments.type'),
          'priority': this.$t('evocall.requests.priority'),
          'predictedAcceptedByNickname': this.$t('virtual_waiting_room.waiting_room.predicted_for'),
          'obs': this.$t('evocall.requests.obs')
        },
        skin: 'table table-striped table-hover is-fullwidth',
        debounce: 500,
        columnsDropdown: false,
        columnsClasses: {
          requestNr: 'text-center',
          locked: 'locked',
          name: 'name',
          phone: 'phone',
          email: 'email',
          entity: 'entity',
          waiting_time: 'text-center',
          status: 'status',
          info: 'info',
          action: 'action',
          updated_at: 'updated_at',
          seen: 'seen',
          obs: 'obs'
        },
        sortIcon: {
          is: 'sort-icon',
          base: 'sort-icon-class',
          up: 'sort-icon-up',
          down: 'sort-icon-down'
        },
        pagination: {
          chunk: 10,
          nav: 'scroll'
        },
        saveState: false,
        storage: 'local'
      },
      showObservationsModal: false,
      showPriorityModal: false,
    }
  },
  created () {
    SocketioService.getQueue(this.$auth.user().id)
    this.loadAuthUserEntityActivityRecords()
  },
  methods: {
    ...mapActions('auth', {
      loadAuthUserEntityActivityRecords: 'LOAD_AUTH_USER_ENTITY_ACTIVITIES'
    }),
    updateObservations: function (request) {
      if (!this.hasPermissionToEntity(request.entity.id, this.infoTypes.REQUESTS, this.accessTypes.WRITE)) {
        return
      }
      this.selectedRequest = request
      this.showObservationsModal = true
    },
    observationsUpdated: function () {
      this.showObservationsModal = false
      this.selectedRequest = null
    },

    // eslint-disable-next-line camelcase
    hasPermissionToEntity: function (entity_id, info_type, access_type) {
      // eslint-disable-next-line camelcase
      return this.virtualWaitingRoomService.user_permissions.some(permission => permission.info_type === info_type && permission.access_type >= access_type && (permission.entity_id === entity_id || permission.entity_id === null))
    },
    updateModalClosed: function () {
      this.showObservationsModal = false
      this.showPriorityModal = false
      this.selectedRequest = null
    },
    getAppointmentTypeRowClass: function (appointmentTypeId) {
      const appointmentType = this.appointmentTypes.find(type => type.bdIds.includes(appointmentTypeId))
      return appointmentType ? appointmentType.rowClass : null
    },
    displayConfirmationModal: function ({ row }) {
      if (row.openedBy === null || row.openedBy === this.authUser.id) {
        //this.$socket.emit('REQUEST_OPENED', { serviceId: this.component.clinical_service_id, requestRow: row })
        SocketioService.emitRequestOpened(row.id)
        this.selectedRequest = {...row}
        this.selectedRequest.openedBy = this.authUser.id
        this.showConfirmationModal = true
      }
    },
    closeConfirmationModal: function () {
      if (this.selectedRequest.openedBy !== null) {
        SocketioService.emitResetRequestOpened(this.selectedRequest.id)
      }
      this.selectedRequest = null
      this.showConfirmationModal = false
    },
    refreshTable: function () {
      this.$refs.requestsTable.refresh()
    },
    priorityUpdatedFromDetailsModal: function ({ request }) {
      this.selectedRequest = request
    },
    getPredictedAudiologistLabel: function (row) {
      const predictedUserId = row.predictedAcceptedBy || row.predicted_accepted_by
      return predictedUserId ? `#${predictedUserId}` : '--'
    },
  },
  computed: {
    filteredRequests: function () {
      return this.requests
    },
    userIsWaitingRoomAdmin: function () {
      if (!this.virtualWaitingRoomService || !this.infoTypes) {
        return false
      }
      return this.virtualWaitingRoomService.user_permissions.some(permission => permission.info_type === this.infoTypes.WAITING_ROOM_ADMIN && permission.access_type >= this.accessTypes.READ)
    },
    columns: function () {
      if (this.userIsWaitingRoomAdmin) {
        return ['locked', 'requestNr', 'createdAt', 'customerNumber', 'entityName', 'facilityName', 'dispenserNickname', 'appointmentType', 'priority', 'estimatedAcceptTime', 'predictedAcceptedByNickname']
      }
      return ['locked', 'requestNr', 'createdAt', 'priority', 'estimatedAcceptTime']
    },
    waitingRoomModuleKey: function () {
      return `virtualWaitingRoom`
    },
    ...mapState({
      authUser (state) {
        return state[`loggedUser`]
      },
      requests (state, getters) {
        //return state[this.waitingRoomModuleKey].requests || []
        return getters[`${this.waitingRoomModuleKey}/requests`]
      },
      infoTypes (state, getters) {
        return state[this.waitingRoomModuleKey].infoTypes || null
      },
      accessTypes (state, getters) {
        return state[this.waitingRoomModuleKey].accessTypes || null
      },
      virtualWaitingRoomService (state) {
        return state.services.find(service => service.url === state.virtual_waiting_room_server) || null
      },
      priorities (state) {
        return state[this.waitingRoomModuleKey].priorities || {}
      },
      appointmentTypes (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/appointmentTypes`] || []
      }
    })
  },
  watch: {
    requests: function(val) {
      if((val.length > 0 && this.selectedRequest !== null && !val.some(elem => elem.id === this.selectedRequest.id)) || (val.length === 0 && this.selectedRequest !== null)) {
        SocketioService.emitResetRequestOpened(this.selectedRequest.id)
        EventBus.$emit('modalClosed')
      }
    }
  }
}
</script>

<style lang="scss">

.call-requests-index {

  .appointment-type-legend {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem 1.5rem;
    margin-top: 1.25rem;
    padding: 1rem 1.25rem;
    background-color: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .appointment-type-legend__title {
    font-weight: 600;
    color: #4a4a4a;
  }

  .appointment-type-legend__items {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem 1.25rem;
  }

  .appointment-type-legend__item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #4a4a4a;
    font-size: 0.9rem;
  }

  .appointment-type-legend__swatch {
    width: 1rem;
    height: 1rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    flex-shrink: 0;
  }

  $primary-red: #c42940;
  $primary-yellow: #c49d29;
  $primary-green: #29c4aa;

  .tooltip.popover {
    &.priority--high {
      .popover-arrow {
        border-color: $primary-red;
      }
    }
    &.priority--normal {
      .popover-arrow {
        border-color: $primary-yellow;
      }
    }
    &.priority--low {
      .popover-arrow {
        border-color: $primary-green;
      }
    }
  }

  #requestsTable {

    i {
      display: block;
      width: 1.5rem;
      height: 1.5rem;
    }

    .priority, .obs, .seen, .locked{
      text-align: center;
    }
    tr:nth-of-type(odd).blocked-row {
      &:hover {
        td.priority{
          color: #6e6e6e;
        }
        background-color: #E8E8E8;
      }
    }

    tr:nth-of-type(even).blocked-row {

      &:hover {
        td.priority{
          color: #6e6e6e;
        }

        background-color: unset;
      }
    }

    .blocked-row {
      td:not(.priority){
        color: rgba(100, 100, 100, 0.25);
      }
      .i-add-comment-gray {
        @extend .i-add-comment-locked;
      }

      .i-has-comment-gray {
        @extend .i-has-comment-locked;
      }

      &:hover {
        .i-add-comment-gray {
          @extend .i-add-comment-locked;
        }

        .i-has-comment-gray {
          @extend .i-has-comment-locked;
        }
      }
    }

    $assetsPath: "../../../assets";
    @import '@/sass/icons/icons-classes.scss';

    tr:hover {
      .i-add-comment-gray {
        @extend .i-add-comment-white;
      }

      .i-has-comment-gray {
        @extend .i-has-comment-white;
      }
    }

    $appointment-type-row-colors: (
      'appointment-type-row--teste': #d6eaf8,
      'appointment-type-row--fitting': #d5f5e3,
      'appointment-type-row--follow-up': #fdebd0,
      'appointment-type-row--follow-up-trial': #ebdef0,
    );

    @each $class, $color in $appointment-type-row-colors {
      tr.#{$class} td {
        background-color: $color;
      }

      .table-hover tbody tr.#{$class}:hover td {
        color: $evollu-gray-light !important;
        background-color: $color !important;
      }

      .table-hover tbody tr.#{$class}:hover i {
        color: $evollu-gray-light !important;
      }

      tr.#{$class}:hover {
        .priority-icon.priority--high {
          color: $primary-red !important;
        }

        .priority-icon.priority--normal {
          color: $primary-yellow !important;
        }

        .priority-icon.priority--low {
          color: $primary-green !important;
        }
      }
    }
  }
}

</style>
